/**
 * Display logs to browser console.
 * @param type
 * @param data
 */
export const mockLogDisplayer = (type, data) => {
  if (process.env.VUE_APP_USE_MOCK === 'false') return false;

  if (type === 'request') {
    if (data.method !== 'get') {
      console.info(`MOCK (Request) ${data.method}: ${data.url}, data: ↓`);
      console.dir(data.data);
    }
  }

  if (type === 'response') {
    console.info(`MOCK (${data.status}) ${data.config.method}:${data.config.url}`);
    if (data.config.params) {
      console.info(`Params`, data.config.params);
    }
    console.dir(data.data);
  }
};
